(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ps-premium-header"] && !Shopify.designMode) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.headerSection    = document.querySelector('.section-header');
    this.isAlwaysSticky   = this.getAttribute('data-sticky-type') === 'always';
    this.headerBounds     = {};
    this.currentScrollTop = 0;
    this.onScrollHandler  = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.createObserver();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    const obs = new IntersectionObserver((entries) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    obs.observe(this.headerSection);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.headerSection.classList.toggle('is-scrolled', scrollTop > 50);
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom + 200) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide()   { if (!this.isAlwaysSticky) this.headerSection.style.transform = 'translateY(-100%)'; }
  reveal() { if (!this.isAlwaysSticky) this.headerSection.style.transform = 'translateY(0)'; }
  reset()  { this.headerSection.style.transform = 'translateY(0)'; }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
